<template>
    <div v-wechat-title="title">
        <crud-facecade
            :url="url"
            :columns="columnList"
            :buttons="[]"
            v-wechat-title="title"
            :tableHeight="tableHeight"
            :addButton="{ permission: 'menu:create' }"
            :deleteButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @LoadShortcutEventView="LoadShortcutEventView"
            @loadImportantEventView="loadImportantEventView"
            @LoadPhysioParamConfig="LoadPhysioParamConfig"
            @LoadTabConfig="LoadTabConfig"
            @LoadMenuTabConfig="LoadMenuTabConfig"
        >
        </crud-facecade>

        <!--快捷事件-->
        <el-dialog class="form-table-h380" title="快捷事件" :visible.sync="shortcutEventView.dialogFormVisible" :close-on-click-modal="false" width="40%">
            <div style="height: 500px">
                <cus-form ref="form-shortcut" :data="shortcutEventView.data" :columns="shortcutEventEditColumns" @extrabutton-click="ExtraButtonClick"></cus-form>
                <ListView :columns="shortcutEventColumns" :datalist="shortcutEvents" @extrabutton-click="ExtraButtonClick" :tableHeight="400"></ListView>
            </div>
            <div style="position: absolute; bottom: 10px; right: 20px">
                <el-button type="default" size="mini" @click="CancelEvent">取消</el-button>
                <el-button type="primary" size="mini" @click="SaveShortcutEvent">保存</el-button>
            </div>
        </el-dialog>

        <!--重要事件-->
        <el-dialog title="重要事件" :visible.sync="importantEventView.dialogFormVisible" :close-on-click-modal="false" width="40%">
            <div style="height: 500px">
                <cus-form ref="form-shortcut" :data="importantEventView.data" :columns="importantEventEditColumns" @extrabutton-click="ExtraButtonClick"></cus-form>
                <ListView :columns="importantEventColumns" :datalist="importantEvents" @extrabutton-click="ExtraButtonClick1" :tableHeight="400"></ListView>
            </div>
            <div style="position: absolute; bottom: 10px; right: 20px">
                <el-button type="default" size="mini" @click="CancelEvent">取消</el-button>
                <el-button type="primary" size="mini" @click="SaveImportantEvent">保存</el-button>
            </div>
        </el-dialog>

        <!--面板-->
        <form-dialog title="面板" :visible.sync="physioParamConfig.dialogFormVisible" :data="physioParamConfig.data" :columns="physioParamColumns" width="50%" @confirm="SavePhysioParamConfig">
        </form-dialog>
        <!--页签-->
        <el-dialog title="页签" v-if="IsUseMenuToRecordTabs == '1'" :visible.sync="tabConfig.dialogFormVisible" :close-on-click-modal="false" width="50%" :destroy-on-close="true">
            <div style="height: 500px">
                <div class="header">
                    <el-button style="float: left" type="primary" size="mini" @click="AddPatientMenus">添 加</el-button>
                </div>
                <list-view :columns="recordTabConfigColumns" :datalist="tabConfig.menuData" @extrabutton-click="ExtraButtonClick1" :tableHeight="400"></list-view>
            </div>
            <div style="position: absolute; bottom: 10px; right: 20px">
                <el-button type="default" size="mini" @click="CancelTabConfig">取消</el-button>
                <el-button type="primary" size="mini" @click="SaveMenuTabConfig">保存</el-button>
            </div>
        </el-dialog>
        <form-dialog title="页签" v-else :visible.sync="tabConfig.dialogFormVisible" :data="tabConfig.data" :columns="tabColumns" width="50%" @confirm="SaveTabConfig"> </form-dialog>
        <!--分配菜单-->
        <tree-dialog
            title="分配菜单"
            :strictly="true"
            :visible.sync="assignMenu.dialogVisible"
            :data="assignMenu.data"
            :default-checked-keys="assignMenu.defaultCheckedKeys"
            @confirm="SavePatientMenus"
        >
            <template slot="row" slot-scope="{ node, data }">
                <span>{{ data.name }}</span>
                <span>
                    {{ data.path }}
                </span>
            </template>
        </tree-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `AnaesthesiaSetting`,
    data() {
        return {
            title: `单据配置`,
            menuList: [],
            shortcutEventView: {
                dialogFormVisible: false,
                data: {}
            },
            shortcutEvents: [],
            importantEventView: {
                dialogFormVisible: false,
                data: {}
            },
            physioParamConfig: {
                dialogFormVisible: false,
                data: { physio_param: [] }
            },
            tabConfig: {
                dialogFormVisible: false,
                data: { tab_param: [] },
                menuData: []
            },
            assignMenu: {
                dialogVisible: false,
                defaultCheckedKeys: [],
                data: []
            },
            importantEvents: {},
            recordType: [],
            recordTemplates: [],
            parentrecord: [],
            currentTemplate: undefined,
            physioParams: [],
            tabParams: [],
            dic_event_config: [],
            dic_event1: [],
            dic_event2: [],
            IsUseMenuToRecordTabs: this.$root.IsUseMenuToRecordTabs,
            IsParent: false
        }
    },
    created() {
        this.init()
        this.loadDicEventConfig()
        this.loaddicevent_SearchEvent()
        this.loaddicevent_Search()
    },
    computed: {
        ...mapGetters([`enum_menus`, `sys_enums`, `menu_icons`, `img_icons`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        url() {
            return {
                baseURL: `/api/AcisSystem/RecordConfig`
            }
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `序号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `select`,
                    prop: `file_name`,
                    label: `文书名称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: this.recordTemplates,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `parent_id`,
                    label: `父级文书`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: this.parentrecord
                },
                {
                    type: `select`,
                    prop: `is_mark_parent`,
                    label: `是否标记到父单据`,
                    isListable: true,
                    isExpand: false,
                    options: `enum_bool`
                },
                {
                    type: `select`,
                    prop: `is_mark_parent`,
                    label: `是否标记到父单据`,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: `enum_bool`
                },
                {
                    type: `select`,
                    prop: `enum_record_type`,
                    label: `单据类型`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: this.recordType,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `textarea`,
                    prop: `description`,
                    label: `描述`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `integer`,
                    prop: `internal_minutes`,
                    label: `显示间隔`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    readonly: false
                },
                {
                    type: `rbool`,
                    prop: `is_delete`,
                    label: `状态`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: `is_enabled`,
                    default: false,
                    readonly: false
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    fixed: `right`,
                    width: `350`,
                    readonly: false,
                    isListable: true,
                    options: (that, { row }) => {
                        let buttons = [
                            {
                                class: `is-plain`,
                                label: `编辑`,
                                type: `primary`,
                                emit: `LoadingUpdateView`,
                                permission: `default`
                            },
                            {
                                class: `is-plain`,
                                label: `快捷事件`,
                                type: `primary`,
                                emit: `LoadShortcutEventView`,
                                permission: `default`
                            },
                            {
                                class: `is-plain`,
                                label: `重要事件`,
                                type: `primary`,
                                emit: `loadImportantEventView`,
                                permission: `default`
                            },
                            {
                                class: `is-plain`,
                                label: `面板`,
                                type: `primary`,
                                emit: `LoadPhysioParamConfig`,
                                permission: `default`
                            }]
                        if (row.enum_surgery_status == 20) {
                            buttons.push({
                                class: `is-plain`,
                                label: `页签`,
                                type: `primary`,
                                emit: `LoadTabConfig`,
                                permission: `default`
                            })
                        } else {
                            buttons.push({
                                class: `is-plain`,
                                label: `页签`,
                                type: `primary`,
                                emit: `LoadMenuTabConfig`,
                                permission: `default`
                            })
                        }
                        return buttons
                    }
                }
            ]
        },
        shortcutEventColumns() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `序号`,
                    colspan: 4,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    colspan: 4,
                    isListable: true,
                    readonly: false,
                    sortable: `asc`
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    colspan: 4,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    colspan: 2,
                    readonly: false,
                    isListable: true,
                    options: [
                        {
                            class: `is-plain`,
                            label: `删除`,
                            type: `danger`,
                            emit: `DeleteShortcutEvent`,
                            permission: `default`
                        }
                    ]
                }
            ]
        },
        shortcutEventEditColumns() {
            return [
                {
                    type: `select`,
                    prop: `name`,
                    label: `名称`,
                    colspan: 18,
                    options: this.dic_event1,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: ``,
                    colspan: 4,
                    options: [
                        {
                            label: `添加`,
                            type: `primary`,
                            emit: `AddShortcutEvent`,
                            permission: `default`
                        }
                    ]
                }
            ]
        },
        importantEventEditColumns() {
            return [
                {
                    type: `select`,
                    prop: `dic_operating_ward_id`,
                    label: `名称`,
                    colspan: 18,
                    isListable: true,
                    options: this.dic_event2,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: ``,
                    colspan: 4,
                    readonly: false,
                    isListable: true,
                    options: [
                        {
                            label: `添加`,
                            type: `primary`,
                            emit: `AddImportantEvent`,
                            permission: `default`
                        }
                    ]
                }
            ]
        },
        importantEventColumns() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `序号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `display_order`,
                    label: `排序`,
                    colspan: 10,
                    isListable: true,
                    readonly: false,
                    sortable: `asc`
                },
                {
                    type: `string`,
                    prop: `dic_id`,
                    label: `排序`,
                    colspan: 10,
                    isListable: false
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    colspan: 10,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `remark`,
                    label: `安全核查`,
                    colspan: 10,
                    isListable: true,
                    readonly: false,
                    meta: {
                        importantEvents: this.importantEvents
                    },
                    options: (that, { row, column }) => {
                        let usedstage = _.map(
                            _.filter(column.meta.importantEvents, d => !!d.remark),
                            d => d.remark
                        )
                        return _.map(this.sys_enums.SaftyCheckStage, d => {
                            d.disabled = usedstage.indexOf(d.value) > -1
                            return d
                        })
                    },
                    change: (that, { row }) => {
                        this.loadSaftyCheckNode(row)
                    }
                },
                {
                    type: `string`,
                    prop: `before_proc`,
                    label: `执行前存储名称`,
                    colspan: 10,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `string`,
                    prop: `after_proc`,
                    label: `执行后存储名称`,
                    colspan: 10,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `string`,
                    prop: `proc_remark`,
                    label: `存储逻辑备注`,
                    colspan: 10,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    colspan: 4,
                    readonly: false,
                    isListable: true,
                    options: [
                        {
                            class: `is-plain`,
                            label: `删除`,
                            type: `danger`,
                            emit: `DeleteImportantEvent`,
                            permission: `default`
                        }
                    ]
                }
            ]
        },
        physioParamColumns() {
            return this.physioParams
        },
        tabColumns() {
            return this.tabParams
        },
        recordTabConfigColumns() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    isListable: true,
                    readonly: false,
                    sortable: `asc`,
                    default: 1
                },
                {
                    type: `string`,
                    prop: `menu_name`,
                    label: `名称`,
                    width: `400`,
                    isListable: true,
                    readonly: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    colspan: 4,
                    readonly: false,
                    isListable: true,
                    options: [
                        {
                            class: `is-plain`,
                            label: `删除`,
                            type: `danger`,
                            emit: `DeleteRecordTabConfig`,
                            permission: `default`
                        }
                    ]
                }
            ]
        }
    },
    methods: {
        AddPatientMenus() {
            let that = this

            that.loadAllMenus().then((allMenu) => {
                let vMenus = _.filter(allMenu, { is_deleted: false })

                let allid = vMenus.map(ar => ar.id)
                let root = _.filter(vMenus, function(r) {
                    return _.indexOf(allid, r.parent_id) == -1 && r.location == `surgery`
                })
                that.assignMenu.dialogVisible = true
                that.assignMenu.data = that.switchToTree(root, vMenus)

                let menuIds = that.tabConfig.menuData.map(menu => menu.menu_id)
                that.assignMenu.defaultCheckedKeys = menuIds || []
            }).catch(function(error) {
                //  网络等其他原因
                console.log(error)
            })
        },
        loadAllMenus() { // 获取患者级菜单
            return this.myaxios.get(`/api/AcisSystem/Menu/Get`)
        },
        SavePatientMenus(e) {
            let that = this

            let checkedMenus = e.map((v, index) => {
                return {
                    display_order: index + 1,
                    menu_id: v.id,
                    menu_name: v.name,
                    id: 0
                }
            })

            let data = _.reduce(
                checkedMenus,
                function(result, value, key) {
                    result.push({
                        display_order: value.display_order,
                        dic_recordtab_id: value.menu_id
                    })
                    return result
                },
                []
            )

            let req = this.myaxios.post(`/api/AcisSystem/RecordConfig/RecordMenuTabConfigs?id=${this.currentTemplate}`, data)
            req.then(data => {
                that.tabConfig.menuData = checkedMenus
                that.assignMenu.dialogVisible = false
            }).catch(e => {
                console.log(e)
            })
        },
        switchToTree(root, menus) {
            return root.map((r) => {
                let children = _.filter(menus, { parent_id: r.id })
                return {
                    id: r.id,
                    name: r.name,
                    path: r.url,
                    children: children.length > 0 ? this.switchToTree(children, menus) : []
                }
            })
        },
        loaddicevent_SearchEvent() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/Event/SearchEvent`)
                req.then(data => {
                    this.dic_event1 = data
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loaddicevent_Search() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/Event/Search`)
                req.then(data => {
                    this.dic_event2 = data
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        init() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/SystemServer/RecordTyps`)
                let req1 = this.myaxios.get(`/api/AcisSystem/SystemServer/RecordTemplates`)
                let req3 = this.myaxios.get(`/api/AcisSystem/RecordTab/Get`)
                let req4 = this.myaxios.get(`/api/AcisSystem/RecordConfig/Get`)

                this.myaxios
                    .all(req, req1, req3, req4)
                    .then(([data, data1, data3, data4]) => {
                        this.recordType = _.map(data, d => {
                            return {
                                value: parseInt(d.code),
                                label: d.label,
                                jianpin: d.jianpin
                            }
                        })
                        this.recordTemplates = _.reduce(
                            data1,
                            function(result, value, key) {
                                result.push({
                                    value: value,
                                    label: value,
                                    jianpin: ``,
                                    code: ``
                                })
                                return result
                            },
                            []
                        )
                        console.log(`this.recordTemplates`)
                        console.log(this.recordTemplates)
                        // 页签选项
                        let recordTabOptions = _.map(data3, d => {
                            return {
                                value: `${d.id}`,
                                label: d.title
                            }
                        })
                        let tabColumns1 = {
                            type: `checkboxgroup`,
                            prop: `tab_param`,
                            label: `页签`,
                            readonly: false,
                            options: recordTabOptions
                        }
                        this.tabParams.push(tabColumns1)
                        this.parentrecord = _.filter(data4, { parent_id: null, enum_record_type: 1 }).map(d => {
                            return {
                                value: d.id,
                                label: d.file_name,
                                jianpin: d.file_name
                            }
                        })
                        console.log(this.parentrecord)
                        console.log(this.recordType)
                    })
                    .catch(e => {
                        console.log(e)
                    })
            })
        },
        loadDicEventConfig() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/Event/Search`)
                req.then(data => {
                    this.dic_event_config =
                        data &&
                        data.map(d => {
                            return {
                                value: d.value,
                                label: d.label,
                                jianpin: d.jianpin
                            }
                        })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        ExtraButtonClick(target) {
            this[target.emit] && this[target.emit](target)
        },
        ExtraButtonClick1(target) {
            this[target.emit] && this[target.emit](target)
        },
        LoadShortcutEventView({ row }) {
            this.shortcutEventView.data = {}
            this.currentTemplate = row && row.id
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/RecordConfig/ShortcutEventConfigs?id=${row && row.id}`)
                req.then(data => {
                    this.shortcutEvents = _.reduce(
                        data,
                        function(result, value, key) {
                            result.push({
                                id: value.evt.id,
                                name: value.evt.name,
                                display_order: value.display_order,
                                abbr: value.evt.abbr,
                                img_name: value.evt.img_name,
                                img_color: value.evt.img_color,
                                alias: value.evt.alias,
                                alias_abbr: value.evt.alias_abbr
                            })
                            return result
                        },
                        []
                    )
                    this.shortcutEventView.dialogFormVisible = true
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadImportantEventView({ row }) {
            this.importantEventView.data = {}
            this.currentTemplate = row && row.id
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/RecordConfig/KeyEventConfigs?id=${row && row.id}`)
                req.then(data => {
                    this.importantEvents = _.reduce(
                        data,
                        function(result, value, key) {
                            result.push({
                                id: value.evt.id,
                                name: value.evt.name,
                                display_order: value.display_order,
                                before_proc: value.before_proc,
                                after_proc: value.after_proc,
                                proc_remark: value.proc_remark,
                                dic_id: value.id,
                                remark: value.remark && parseInt(value.remark)
                            })
                            return result
                        },
                        []
                    )
                    this.importantEventView.dialogFormVisible = true
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        AddImportantEvent({ formdata }) {
            let item = _.find(this.dic_event2, { value: formdata.dic_operating_ward_id })
            let data = {
                id: item.value,
                name: item.label,
                display_order: ((_.last(this.importantEvents) && _.last(this.importantEvents).display_order) || 0) + 1
            }
            let r = _.findIndex(this.importantEvents, function(o) {
                return o.id == data.id
            })
            if (r !== -1) {
                this.$message.warning(`事件重复`)
                return false
            }
            this.importantEvents = this.importantEvents.concat(data)
            this.importantEventView.data = {}
        },
        DeleteImportantEvent({ index, row }) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    this.importantEvents.splice(index, 1)
                })
                .catch(e => {
                    console.log(e)
                })
        },
        SaveImportantEvent() {
            let data = _.reduce(
                this.importantEvents,
                function(result, value, key) {
                    result.push({
                        display_order: value.display_order,
                        dic_event_id: value.id,
                        before_proc: value.before_proc,
                        after_proc: value.after_proc,
                        proc_remark: value.proc_remark,
                        remark: value.remark
                    })
                    return result
                },
                []
            )
            let req = this.myaxios.post(`/api/AcisSystem/RecordConfig/KeyEventConfigs?id=${this.currentTemplate}`, data)
            req.then(data => {
                this.importantEventView.dialogFormVisible = false
            }).catch(e => {
                console.log(e)
            })
        },
        CancelEvent() {
            this.importantEventView.dialogFormVisible = false
            this.shortcutEventView.dialogFormVisible = false
        },
        AddShortcutEvent({ formdata }) {
            let item = _.find(this.dic_event1, { value: formdata.name })
            let data = {
                id: item.value,
                name: item.label,
                display_order: ((_.last(this.shortcutEvents) && _.last(this.shortcutEvents).display_order) || 0) + 1
            }
            let r = _.findIndex(this.shortcutEvents, function(o) {
                return o.id == data.id
            })
            if (r !== -1) {
                this.$message.warning(`事件重复`)
                return false
            }
            this.shortcutEvents = this.shortcutEvents.concat(data)
            this.shortcutEventView.data = {}
        },
        DeleteShortcutEvent({ index, row }) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    this.shortcutEvents.splice(index, 1)
                })
                .catch(e => {
                    console.log(e)
                })
        },
        SaveShortcutEvent() {
            let data = _.reduce(
                this.shortcutEvents,
                function(result, value, key) {
                    result.push({
                        display_order: value.display_order,
                        dic_event_id: value.id
                    })
                    return result
                },
                []
            )
            let req = this.myaxios.post(`/api/AcisSystem/RecordConfig/ShortcutEventConfigs?id=${this.currentTemplate}`, data)
            req.then(data => {
                this.shortcutEventView.dialogFormVisible = false
            }).catch(e => {
                console.log(e)
            })
        },
        SavePhysioParamConfig(row) {
            let data = _.reduce(
                row.physio_param,
                function(result, value, key) {
                    result.push({
                        dic_physio_param_id: value
                    })
                    return result
                },
                []
            )
            let req = this.myaxios.post(`/api/AcisSystem/RecordConfig/PhysioParamConfigs?id=${this.currentTemplate}`, data)
            req.then(data => {
                this.physioParamConfig.dialogFormVisible = false
            }).catch(e => {
                console.log(e)
            })
        },
        LoadPhysioParamConfig({ row }) {
            this.physioParamConfig.data = {
                physio_param: []
            }
            this.physioParams = []
            this.physioParamConfig.dialogFormVisible = true
            this.currentTemplate = row && row.id
            console.log(row)
            return new Promise(resolve => {
                let req1 = this.myaxios.get(`/api/AcisSystem/RecordConfig/PhysioParamConfigs?id=${row && row.id}`)
                let req2 = this.myaxios.get(`/api/AcisSystem/PhysioParam/Get?surgeryId=0&current_surgery=0&record_type=${row.enum_record_type}`)
                this.myaxios
                    .all(req1, req2)
                    .then(([data1, data2]) => {
                        let r = _.groupBy(data2, function(d) {
                            return d.enum_physio_param_category
                        })
                        for (let key in r) {
                            let options = _.reduce(
                                r[key],
                                function(result, value, key) {
                                    result.push({
                                        value: `${value.id}`,
                                        label: value.name
                                    })
                                    return result
                                },
                                []
                            )
                            let columns = {
                                type: `checkboxgroup`,
                                prop: `physio_param`,
                                label: r[key][0].physio_param_category,
                                readonly: false,
                                options: options
                            }
                            this.physioParams.push(columns)
                        }
                        console.log(`physioParams 1`)
                        console.log(this.physioParams)

                        this.physioParamConfig.data.physio_param = data1.map(r => r.physio_param.id) || []
                        this.physioParamConfig.dialogFormVisible = true
                        console.log(this.physioParamConfig.data)
                    })
            })
        },
        LoadTabConfig({ row }) {
            // 加载页签配置
            this.tabConfig.data = {
                tab_param: []
            }
            this.tabConfig.dialogFormVisible = true
            this.currentTemplate = row && row.id
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/RecordConfig/RecordTabConfigs?id=${row && row.id}`)
                req.then(data => {
                    this.tabConfig.data.tab_param = data.map(r => r.tab.id) || []
                    // this.tabConfig.data = data || []
                    this.tabConfig.dialogFormVisible = true
                    console.log(`tabconfig.data`)
                    console.log(this.tabConfig.data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        LoadMenuTabConfig({ row }) {
            // 加载页签配置
            let that = this
            that.currentTemplate = row && row.id
            return new Promise(resolve => {
                let req = that.myaxios.get(`/api/AcisSystem/RecordConfig/RecordTabMenus?id=${row && row.id}`)
                req.then(data => {
                    that.tabConfig.menuData = _.map(data, d => {
                        return {
                            menu_id: d.dic_recordtab_id,
                            menu_name: d.menu_tab && d.menu_tab.name,
                            display_order: d.display_order,
                            id: d.id
                        }
                    })
                    that.tabConfig.dialogFormVisible = true
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        SaveTabConfig(row) {
            let data = _.reduce(
                row.tab_param,
                function(result, value, key) {
                    result.push({
                        dic_recordtab_id: value
                    })
                    return result
                },
                []
            )
            let req = this.myaxios.post(`/api/AcisSystem/RecordConfig/RecordTabConfigs?id=${this.currentTemplate}`, data)
            req.then(data => {
                this.tabConfig.dialogFormVisible = false
            }).catch(e => {
                console.log(e)
            })
        },
        CancelTabConfig() {
            this.tabConfig.dialogFormVisible = false
        },
        SaveMenuTabConfig() {
            let data = _.reduce(
                this.tabConfig.menuData,
                function(result, value, key) {
                    result.push({
                        display_order: value.display_order,
                        dic_recordtab_id: value.menu_id
                    })
                    return result
                },
                []
            )
            let req = this.myaxios.post(`/api/AcisSystem/RecordConfig/RecordMenuTabConfigs?id=${this.currentTemplate}`, data)
            req.then(data => {
                this.tabConfig.dialogFormVisible = false
            }).catch(e => {
                console.log(e)
            })
        },
        DeleteRecordTabConfig({ index, row }) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                this.tabConfig.menuData.splice(index, 1)
            }).catch(e => {
                console.log(e)
            })
        },
        loadSaftyCheckNode(row) {
            let req = this.myaxios.post(`/api/Intraoperative/SaftyCheck/SaftyCheckBinding?keyEventConfigId=${row.dic_id}&enumSaftyCheck=${row.remark || -1}`)
            req.then(data => {}).catch(e => {
                console.log(e)
            })
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/AnaesthesiaSetting/Index.vue